import { Button, Center, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Text, VStack } from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import useModelAnexoChamada from './useModelAnexoChamada';
import { FaPaperclip } from 'react-icons/fa';
import { FaRegTrashAlt } from 'react-icons/fa';

function ModalAnexoChamada(props) {
  const disclosure = props.disclosure;
  const agenda_exames_id = props?.agenda_exames_id;
  const { theme, selectedFiles, handleFileChange, handleExcludeFile, handleSubmitFiles, errorSubmit, loading } = useModelAnexoChamada({
    agenda_exames_id,
    disclosure,
  });

  const inputRef = useRef(null);

  const handleButtonClick = () => {
    inputRef.current.click();
  };

  return (
    <>
      <Modal isOpen={disclosure.isOpen} isCentered>
        <ModalOverlay />
        <ModalContent maxW="95%" h="auto" borderRadius="0.8em">
          <ModalCloseButton mt={1} color={'#9E9E9E'} onClick={() => disclosure.onClose()} _focus={false} />
          <ModalBody>
            <VStack p={5}>
              <FaPaperclip fill={theme.background} size={50} />
              <Text color={'#616161'} fontWeight={'bold'} textAlign={'center'} fontSize={'1.2em'}>
                Anexe aqui os arquivos que deseja enviar para o seu médico avaliar.
              </Text>
              <input type="file" multiple ref={inputRef} style={{ display: 'none' }} onChange={handleFileChange} />
              <Button color={'white'} bg={theme.background} borderRadius={'0.8em'} w={'80%'} onClick={handleButtonClick}>
                <FaPaperclip fill={'white'} size={20} /> <Text ml={'5%'}> Escolher o arquivo</Text>
              </Button>
              {selectedFiles?.length > 0 && (
                <VStack mt={4} spacing={1} w="100%">
                  {selectedFiles.map((file, index) => {
                    return (
                      <HStack borderRadius={'0.8em'} p={4} bg={'#F3F3F3'} mt={'1em'}>
                        <Text key={index} fontSize="1em" color="gray.600">
                          {file.name}
                        </Text>
                        <FaRegTrashAlt fill="red" size={30} onClick={() => handleExcludeFile(index)} />
                      </HStack>
                    );
                  })}
                </VStack>
              )}
            </VStack>
            {selectedFiles?.length > 0 && (
              <>
                {errorSubmit && (
                  <Text fontWeight={'bold'} fontSize={'1em'} color={'red'}>
                    {errorSubmit}
                  </Text>
                )}
                <Center mt={'1em'} mb={'1em'}>
                  <Button color={'white'} bg={theme.background} borderRadius={'0.8em'} w={'100%'} onClick={handleSubmitFiles} loading={loading}>
                    {loading ? 'Aguarde...' : 'Já selecionei todos!'}
                  </Button>
                </Center>
              </>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalAnexoChamada;
